<div class="console-page">

  <div class="console-content">

    <app-page-header

      title="Generador Excel iZipay por lote"

      description="Plantilla Excel con tokens, subida al servicio y generación del archivo F5."

    ></app-page-header>



    <app-console-section title="Instrucciones">

      <ol class="console-section__desc">

        <li><strong>Descargar plantilla:</strong> Haz clic en «Descargar plantilla Excel» (columna <strong>Token</strong>).</li>

        <li><strong>Completar tokens:</strong> Una fila por payment token.</li>

        <li><strong>Subir archivo:</strong> Selecciona el Excel con los tokens.</li>

        <li><strong>Generar TXT:</strong> El front envía los tokens al servicio y descarga el F5.</li>

      </ol>

    </app-console-section>



    <app-console-section title="Configuración">

      <div class="console-form-grid">

        <div class="console-field">

          <label class="console-field__label" for="apiUrl">URL del servicio</label>

          <input type="text" id="apiUrl" class="console-input" [(ngModel)]="apiUrl" placeholder="URL del servicio" />

          <span class="console-field__hint">URL base del servicio iZipay File Service</span>

        </div>

        <div class="console-field">

          <label class="console-field__label" for="fileName">Nombre del archivo</label>

          <input type="text" id="fileName" class="console-input" [(ngModel)]="fileName" placeholder="Nombre del archivo" />

          <span class="console-field__hint">Nombre del archivo TXT que se generará</span>

        </div>

      </div>

    </app-console-section>



    <app-console-section title="Plantilla Excel">

      <p class="console-section__desc">Plantilla con columna <strong>Token</strong>. Una fila por payment token.</p>

      <button type="button" class="console-btn" (click)="downloadTemplate()">Descargar plantilla Excel (tokens)</button>

    </app-console-section>



    <app-console-section title="Subir Excel con tokens">

      <p class="console-section__desc">Selecciona el Excel con la columna Token (uno por fila):</p>

      <input type="file" #fileInput (change)="handleFileSelect($event)" accept=".xlsx,.xls" />

      <span class="console-field__hint">Solo archivos Excel (.xlsx, .xls)</span>

    </app-console-section>



    <app-console-section title="Generar archivo TXT">

      <div class="status" [ngClass]="statusClass" [style.display]="statusMessage ? 'block' : 'none'">

        {{ statusMessage }}

      </div>

      <div class="console-actions">

        <button type="button" class="console-btn console-btn--primary" (click)="generateFromExcel()" [disabled]="!selectedFile || isLoading">

          Generar TXT desde servicio

        </button>

      </div>

    </app-console-section>

  </div>

</div>

